<template>
  <div class="btn-group w-full">
    <div @click="toggleMenu()" class="dropdown-toggle dropdown-toggle-placeholder h-full">
      ...
    </div>

    <ul class="dropdown-menu" v-if="showMenu">
      <li v-for="(option, idx) in options" :key="idx" class="text-left">
        <a href="javascript:void(0)" @click="updateOption(option)" v-if="option.name">
          {{ option.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMenu: false,
      placeholderText: '...',
    }
  },
  props: {
    options: {
      type: [Array, Object]
    },
    placeholder: [String],
    closeOnOutsideClick: {
      type: [Boolean],
      default: true,
    },
  },

  mounted() {
    if (this.placeholder) {
      this.placeholderText = this.placeholder;
    }

    if (this.closeOnOutsideClick) {
      document.addEventListener('click', this.clickHandler);
    }
  },

  beforeDestroy() {
    document.removeEventListener('click', this.clickHandler);
  },

  methods: {
    updateOption(option) {
      this.showMenu = false;
      this.$emit('updateOption', option);
    },

    toggleMenu() {
      this.showMenu = !this.showMenu;
    },

    clickHandler(event) {
      const {target} = event;
      const {$el} = this;

      if (!$el.contains(target)) {
        this.showMenu = false;
      }
    },
  }
}
</script>